import { ReportBuilder } from '../components/ReportBuilder'

export default function ReportsBuilderPage() {
  return (
    <div className="p-4 sm:p-6 max-w-7xl mx-auto space-y-4">
      <header>
        <h1 className="text-2xl font-semibold text-[#102a43]">Reports</h1>
        <p className="text-sm text-[#556B7C]">
          Build saved reports across projects, tasks, time, programs, and portfolios. Export to
          CSV, Excel, PDF, or PowerPoint, or schedule recurring sends.
        </p>
      </header>
      <ReportBuilder />
    </div>
  )
}
